import React from 'react';

function ConcludedCases() {
	return <div>ConcludedCases</div>;
}

export default ConcludedCases;
